import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/components/layout'
Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior (){
        return {x:0, y:0}
    },
    routes: [
        {
            path:'/',
            meta: { title: '首页' },
            redirect: '/',
            component: layout,
            children: [
                {
                    path: '/',
                    meta: { title: '首页' },
                    component: resolve => require(['@/pages/home'], resolve)
                },
                {
                    path: 'product',
                    meta: { title: '产品介绍' },
                    component: resolve => require(['@/pages/product'], resolve)
                },
                {
                    path: 'trends',
                    meta: { title: '公司动态' },
                    component: resolve => require(['@/pages/trends'], resolve)
                },
                {
                    path: 'strength',
                    meta: { title: '企业实力' },
                    component: resolve => require(['@/pages/strength'], resolve)
                }
            ]
        }
    ]
})

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}